import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=cc165a8c&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=ts&"
export * from "./NewsArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc165a8c",
  null
  
)

export default component.exports